// extracted by mini-css-extract-plugin
export var container = "_fj-1";
export var cornerButtonContainer = "_fj-6";
export var disabled = "_fj-2";
export var dragActive = "_fj-3";
export var fileContainer = "_fj-5";
export var hiddenInput = "_fj-4";
export var widthContainer = "_fj-0";